import * as React from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { request } from "../../services/cpln";
import { Loader } from "../../components/layout/loader";
import { Helmet } from "react-helmet";
import { IS_DEPLOYMENT_ENV_TEST } from "../../envVariables";
import { Command } from "../../schema/types/command";
import { ArrowLeft, RefreshCw } from "react-feather";
import { BasePathContext } from "../../reactContexts/basePathContext";
import NGAlert from "../../newcomponents/alert";
import { NGButton } from "../../newcomponents/button/Button";
import { CodeEditor } from "../../pages/group/identityMatcher/codeEditor";
import { CommandActions } from "./commandActions";

type RouteParams = "commandId";
interface Props {
  itemLink: string;
  containerName?: string;
}
export const CommandDetail: React.FC<Props> = ({ itemLink, containerName }) => {
  const { commandId } = useParams<RouteParams>();
  const [searchParams] = useSearchParams();
  const fromExecutions = searchParams.get("fromExecutions");

  const navigate = useNavigate();
  const basePath = React.useContext(BasePathContext);

  const [isLoading, setIsLoading] = React.useState(true);
  const [isRefreshing, setIsRefreshing] = React.useState(false);
  const [command, setCommand] = React.useState<Command>(null as any);

  React.useEffect(() => {
    fetchCommand();
  }, []);

  async function fetchCommand(isRefresh = false) {
    try {
      if (isRefresh) {
        setIsRefreshing(true);
      } else {
        setIsLoading(true);
      }
      const { data } = await request({ url: `${itemLink}/-command/${commandId}` });
      setCommand(data);
    } catch (e) {
    } finally {
      setIsLoading(false);
      setIsRefreshing(false);
    }
  }

  if (isLoading) {
    return <Loader fullScreen reason={"fetching workload to show detail"} />;
  }

  return (
    <>
      <Helmet>
        <title>
          {IS_DEPLOYMENT_ENV_TEST ? `TEST | ` : ""}
          {command?.id || "Command"} - Command - From many clouds, one™
        </title>
      </Helmet>
      <div className="flex items-center mb-4 gap-4">
        {fromExecutions ? (
          <button className="ngfocus color-link" onClick={() => navigate(`${basePath}/-jobexecutions`)}>
            <ArrowLeft className="mr-1 feather-icon inline-block" style={{ transform: "translateY(2px)" }} />
            <span>Back to Job Executions</span>
          </button>
        ) : (
          <button className="ngfocus color-link" onClick={() => navigate(`${basePath}/-commands`)}>
            <ArrowLeft className="mr-1 feather-icon inline-block" style={{ transform: "translateY(2px)" }} />
            <span>Back to Commands</span>
          </button>
        )}
        <NGButton
          variant="secondary"
          size="small"
          outlined
          onClick={() => fetchCommand(true)}
          disabled={isRefreshing}
          loading={isRefreshing}
          renderIcon={(_, props) => <RefreshCw {...props} />}
        >
          Refresh
        </NGButton>
      </div>
      {command ? (
        <>
          <CommandActions command={command} containerName={containerName} />
          <div className="text-sm">
            <CodeEditor
              value={JSON.stringify(command, null, 2)}
              language="json"
              setValue={() => {}}
              options={{ readOnly: true }}
            />
          </div>
        </>
      ) : null}
      {command ? null : <NGAlert type="warning" title="Command is not found" />}
    </>
  );
};
